import moment from 'moment';

export const formatTimestampForChat = (date) => {
  const now = moment();
  const messageDate = moment(date);

  if (now.isSame(messageDate, 'day')) {
    return messageDate.format('h:mm A'); // Same day (e.g., 12:45 PM)
  } else if (now.subtract(1, 'day').isSame(messageDate, 'day')) {
    return "Yesterday";
  } else {
    return messageDate.format('MM-DD-YYYY'); // Older messages
  }
};

export const formatTimestampForMessage = (date) => {
  const now = moment();
  const messageDate = moment(date);

  if (now.isSame(messageDate, 'day')) {
    return messageDate.format('h:mm A'); // Same day (e.g., 12:45 PM)
  } else if (now.subtract(1, 'day').isSame(messageDate, 'day')) {
    return `Yesterday ${messageDate.format('h:mm A')}`;
  } else {
    return messageDate.format('MM-DD-YYYY h:mm A'); // Older messageś
  }
};

export const getLastActiveStatus = (date) => {
  const now = moment();
  const lastActiveTime = moment(date);

  const diffInMinutes = now.diff(lastActiveTime, 'minutes');

  if (diffInMinutes < 1) {
    return 'Active now';
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} minutes ago`;
  } else if (diffInMinutes < 1440) { // Less than 24 hours
    return `${Math.floor(diffInMinutes / 60)} hours ago`;
  } else if (now.subtract(1, 'day').isSame(lastActiveTime, 'day')) {
    return 'Yesterday';
  } else {
    return lastActiveTime.fromNow(); // Example: "3 days ago"
  }
};

export const convertToISO = (dateString) => moment(dateString).toISOString();